import { Route, Routes } from 'react-router-dom'
import OptionGroup from '../pages/main'
import { OptionGroupProvider } from '../provider'
import OptionGroupForm from '../pages/form'

const OptionGroupRoutes = () => {
    return (
        <OptionGroupProvider>
            <Routes>
                <Route path="/" element={<OptionGroup />} />
                <Route path="form" element={<OptionGroupForm />} />
                <Route path="form/:id" element={<OptionGroupForm />} />
            </Routes>
        </OptionGroupProvider>
    )
}

export default OptionGroupRoutes
